import styled from '@emotion/styled';
import { MixinFocusVisible } from '../structure/DefaultStyles';

export const Summary = styled.summary`
    font-weight: 900;
    list-style: none;
    display: flex;
    align-items: center;
    font-weight: 900;
    gap: 0.5rem;
    ${MixinFocusVisible}
    ::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 10px solid ${(props) => props.theme.color.text};
        border-inline: 7px solid transparent;
        transition: 0.2s;
    }
`;

export const Article = styled.article`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    color: ${(props) => props.theme.color.text};
    p {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: ${(props) => props.theme.color.text};
    }
`;

export const Details = styled.details`
    padding: 1rem;
    border-radius: 6px;
    border-left: 4px solid ${(props) => props.theme.color.text};
    &[open] {
        & > summary::after {
            transform: rotate(180deg);
        }
    }
    &:focus-within {
        outline: ${(props) => props.theme.color.text} auto 2px;
    }
`;

export const Subtitle = styled.span`
    font-weight: 100;
`;
